import { render, staticRenderFns } from "./trainingPage.vue?vue&type=template&id=0299edf3&scoped=true"
import script from "./trainingPage.vue?vue&type=script&lang=ts"
export * from "./trainingPage.vue?vue&type=script&lang=ts"
import style0 from "./trainingPage.vue?vue&type=style&index=0&id=0299edf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0299edf3",
  null
  
)

export default component.exports